/**
 * Constants for addon price types
 * These match the database price_types table values
 */

export const ADDON_PRICE_TYPES = {
  PER_PERSON: "per_person",
  INDIVIDUAL: "individual",
} as const;

export const MAX_ADDON_DESCRIPTION_WORDS = 24;

export type AddonPriceType =
  (typeof ADDON_PRICE_TYPES)[keyof typeof ADDON_PRICE_TYPES];

// For backward compatibility and type checking
export const isPerPersonPricing = (priceType: string): boolean => {
  return priceType === ADDON_PRICE_TYPES.PER_PERSON;
};

export const isIndividualPricing = (priceType: string): boolean => {
  return priceType === ADDON_PRICE_TYPES.INDIVIDUAL;
};
